import { useState } from 'react'
import { FileText } from 'lucide-react'
import PdfViewerModal from '../ui/PdfViewerModal'

function LogoTile({ logo, onPdfOpen }) {
  const isClickable = Boolean(logo.pdf)
  const inner = (
    <>
      {logo.image ? (
        <div className="flex h-16 w-full min-w-0 items-center justify-center overflow-hidden">
          <img
            src={logo.image}
            alt={logo.name}
            className="max-h-14 w-auto max-w-full object-contain"
          />
        </div>
      ) : (
        <span className="text-sm font-bold text-primary">{logo.name}</span>
      )}
      {isClickable && (
        <span className="inline-flex items-center gap-1 text-xs font-medium text-text/50 group-hover:text-primary/70">
          <FileText className="h-3.5 w-3.5" />
          View PDF
        </span>
      )}
    </>
  )

  const className =
    'group flex min-h-[100px] w-full min-w-0 flex-col items-center justify-center gap-2 overflow-hidden rounded-xl border border-border bg-white px-3 py-4 text-center shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary/30 hover:shadow-lg hover:shadow-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 sm:px-4 sm:py-5'

  if (isClickable) {
    return (
      <button
        type="button"
        onClick={() => onPdfOpen({ src: logo.pdf, title: logo.name })}
        className={className}
      >
        {inner}
      </button>
    )
  }

  return <div className={className}>{inner}</div>
}

export default function LogoGrid({ logos, title }) {
  const [activePdf, setActivePdf] = useState(null)

  return (
    <>
      <section className="my-10">
        {title && (
          <h3 className="mb-6 text-center text-xl font-bold text-primary">{title}</h3>
        )}
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 lg:grid-cols-4">
          {logos.map((logo) => (
            <LogoTile
              key={logo.slug || logo.name}
              logo={logo}
              onPdfOpen={setActivePdf}
            />
          ))}
        </div>
      </section>

      <PdfViewerModal
        isOpen={Boolean(activePdf)}
        onClose={() => setActivePdf(null)}
        src={activePdf?.src}
        title={activePdf?.title}
      />
    </>
  )
}
